import PropTypes from 'prop-types'
import { memo, useMemo } from 'react'
import Item from './Item/Item'
import styles from './NavList.module.scss'

/**
 * The `NavList`
 *
 * @param {object} props - the component props
 * @returns {React.ReactElement} the element
 */
function NavListComponent (props) {
  const { children, className, type } = props

  const attributes = useMemo(
    () => ({
      className: `${styles.nav} ${className}`.trimEnd(),
      'data-t': type
    }),
    [type, className]
  )

  return (
    <nav {...attributes}>
      <ul>{children}</ul>
    </nav>
  )
}

/** @type {object} */
NavListComponent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  type: PropTypes.string
}

/** @type {object} */
NavListComponent.defaultProps = {
  children: null,
  className: '',
  type: 'a'
}

// Memoize
const NavList = memo(NavListComponent)

// Bind the types
NavList.Item = Item

// Export
export default NavList
